import { render, staticRenderFns } from "./TradeSuccess.vue?vue&type=template&id=fa43f512&scoped=true&"
import script from "./TradeSuccess.vue?vue&type=script&lang=js&"
export * from "./TradeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TradeSuccess.vue?vue&type=style&index=0&id=fa43f512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa43f512",
  null
  
)

export default component.exports